export default {
    header: {
        profile: 'Профиль',
        exit: 'Выход',
    }
}
